import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

import useParent from '../../../hooks/useParent';
import UnderConstruction from '../UnderContructionWrapper';

const ParentGuide = () => {
  const { currentChild } = useParent();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentChild) {
      navigate('/parent/settings', { state: { label: 'Account Information' } });
    }
  }, [currentChild, navigate]);
  return (
    <UnderConstruction
      icon={<BookOpen size={48} />}
      title="Parent’s Guide Under Construction"
      description="Our guide content is on the way—tips, FAQs, and best practices for parents coming soon!"
    />
  );
};

export default ParentGuide;
